import script from "./WidgetContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetContainer.vue?vue&type=script&setup=true&lang=js"

import "./WidgetContainer.vue?vue&type=style&index=0&id=18f03c8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f03c8e"]])

export default __exports__